import * as pConst from "../consts/profiles-consts.js";
import * as wConst from "../consts/website-consts.js";

export const InitState = {
  SearchResults: {
    Loaded: false,
    ApiResult: {
      Code: 500, Message: "Empty"
    }
  },
  SearchGroups: {
    Loaded: false,
    ApiResult: {
      Code: 500, Message: "Empty", Result: []
    }
  }

};

export const searchReducer = (state = InitState, action) => {
  switch (action.type) {
    case wConst.FETCH_SEARCH_PENDING: {
      state = {...state, SearchResults: {...state.SearchResults, Loaded: false}, SearchGroups: {...state.SearchGroups, Loaded: false}};
      break;
    }
    case wConst.FETCH_SEARCH_REJECTED: {
      state = {...state, SearchResults: {ApiResult: action.payload, Loaded: true}, SearchGroups: {...state.SearchGroups, Loaded: false}};
      break;
    }
    case wConst.FETCH_SEARCH_FULLFILLED: {
      state = {...state, SearchResults: {ApiResult: action.payload, Loaded: true}, SearchGroups: {...state.SearchGroups, Loaded: false}};
      break;
    }
    case wConst.FETCH_SEARCHGROUPS_PENDING: {
      state = {...state, SearchGroups: {...state.SearchGroups, Loaded: false},  SearchResults: {...state.SearchResults, Loaded: false},};
      break;
    }
    case wConst.FETCH_SEARCHGROUPS_REJECTED: {
      state = {...state, SearchGroups: {ApiResult: action.payload, Loaded: true},  SearchResults: {...state.SearchResults, Loaded: false},};
      break;
    }
    case wConst.FETCH_SEARCHGROUPS_FULLFILLED: {
      state = {...state, SearchGroups: {ApiResult: action.payload, Loaded: true},  SearchResults: {...state.SearchResults, Loaded: false},};
      break;
    }



  }
  return state;
};


